const en = {
  translation: {
    // Navigation
    'home': 'Home',
    'about_us': 'About Us',
    'services': 'Services',
    'contact': 'Contact',
    'locations': 'Locations',

    // Home page content
    'hero_title': 'Airline Crew Transportation',
    'hero_title_first_line': 'Airline Crew',
    'hero_title_second_line': 'Transportation',
    'hero_subtitle': 'We are the number one transportation provider in San Francisco, Los Angeles, Silicon Valley, Florida, New York City, Texas, and Sydney, Australia.',
    'hero_cta_first_line': 'Talk to',
    'hero_cta_second_line': 'Transportation',
    'hero_cta_third_line': 'Concierge',
    'hero_cta': 'Talk to Transportation Concierge',

    // About section
    'about_title': 'About Us',
    'about_description': 'is North America\'s leading Flight Crew & Hotel Shuttle Service provider. For nearly 30 years, we\'ve been at the forefront of providing reliable, safe, and efficient transport solutions for airline crews around the world.',
    'about_years': 'Years of Excellence',
    'about_global_locations': 'Global Locations',
    'about_service': 'Service & Support',
    'get_in_touch': 'Talk to Our Airline Crew Transportation Concierge',
    'about_second_paragraph': 'Our dedication to excellence, punctuality, and customer satisfaction has made us the preferred choice for numerous international airlines. We understand the unique needs of flight crews and have tailored our services to ensure a comfortable and stress-free experience from pickup to drop-off.',

    // In Good Company section
    'in_good_company_title': 'In Good Company',
    'in_good_company_description': 'Trusted by the world\'s leading airlines for reliable and premium transportation services.',

    // Testimonials section
    'testimonials_title': 'What Our Clients Say',
    'testimonials_description': 'Discover why leading airlines and clients choose us for their transportation needs.',

    // Testimonial quotes
    'testimonial_1_quote': "I had such a great time working and finalizing our flight crew's summer schedule with Airline Crew Transportation's manager.",
    'testimonial_1_author': "SAS Airlines",
    'testimonial_1_company': "Station Manager",

    'testimonial_2_quote': "We have finally found a GEM.",
    'testimonial_2_author': "Aish Wedding Services",
    'testimonial_2_company': "CEO and Manager",

    'testimonial_3_quote': "It was great one less thing to worry about and I was set at ease when I was recommended Airline Crew Transportation for our flight and cabin crew's transportation to and from the hotel.",
    'testimonial_3_author': "El-Al Airlines",
    'testimonial_3_company': "Station Manager",

    // Services section
    'services_title': 'Our Services',
    'services_description': 'Explore our premium transportation options, each designed to meet your specific needs with comfort and reliability.',
    'select_a_service': 'Select a Service',
    'get_a_quote': 'Talk to Transportation Concierge',

    // Service items
    'service_airport_transfer_title': 'Airport Transfer',
    'service_airport_transfer_bullet1': 'Punctual pickups and drop-offs for smooth operations.',
    'service_airport_transfer_bullet2': 'Clean, well-equipped vehicles for every ride.',

    'service_distressed_passengers_title': 'Distressed Passengers Transport',
    'service_distressed_passengers_bullet1': '24/7 rapid response for flight delays and cancellations.',
    'service_distressed_passengers_bullet2': 'Efficient passenger relocation to hotels or alternative airports.',

    'service_any_occasion_title': 'Any Occasion Car Services',
    'service_any_occasion_bullet1': 'Premium transportation for corporate events and meetings.',
    'service_any_occasion_bullet2': 'Professional service ensuring executives arrive refreshed.',

    'service_hotel_transfer_title': 'Hotel Transfer',
    'service_hotel_transfer_bullet1': 'Seamless coordination between accommodations and airports.',
    'service_hotel_transfer_bullet2': 'Perfect timing for early departures and late arrivals.',

    'service_flight_cabin_crew_title': 'Flight & Cabin Crew Shuttle',
    'service_flight_cabin_crew_bullet1': 'Specialized service understanding airline operational requirements.',
    'service_flight_cabin_crew_bullet2': 'Strict adherence to timing protocols for crew schedules.',

    'service_company_shuttle_title': 'Company Shuttle Services',
    'service_company_shuttle_bullet1': 'Customized transportation solutions for employees and executives.',
    'service_company_shuttle_bullet2': 'Regular routes with real-time tracking and cost efficiency.',

    'service_charter_services_title': 'Charter Services',
    'service_charter_services_bullet1': 'Tailored transportation solutions for groups of all sizes.',
    'service_charter_services_bullet2': 'Professional logistics planning with custom fleet options.',

    // Fleet section
    'fleet_title': 'Our Fleet',
    'fleet_description': 'Discover our diverse fleet of luxury vehicles, each selected to provide exceptional comfort, style, and reliability for all your transportation needs.',
    'select_a_vehicle': 'Select a Vehicle',

    // Fleet items
    'fleet_sedan_title': 'Sedan',
    'fleet_sedan_description': 'Luxury sedans for executive travel with professional chauffeurs. Up to 3 seats.',

    'fleet_suv_title': 'SUV',
    'fleet_suv_description': 'Premium SUVs offering spacious comfort for small groups. Up to 6 seats.',

    'fleet_sprinter_title': 'Sprinter',
    'fleet_sprinter_description': 'Mercedes-Benz Sprinter vans with luxury amenities for medium-sized groups. Up to 14 seats.',

    'fleet_minibus_title': 'Minibus',
    'fleet_minibus_description': 'Comfortable minibuses for larger groups with ample luggage space. Up to 27 seats.',

    'fleet_mini_coach_title': 'Mini Coach',
    'fleet_mini_coach_description': 'Mini coaches offering premium transport for medium to large groups. Up to 35 seats.',

    'fleet_coach_title': 'Coach',
    'fleet_coach_description': 'Full-sized luxury coaches for large group transportation needs. Up to 55 seats.',

    // Fleet vehicle details (for carousel)
    'fleet_van_title': 'Van',
    'fleet_van_capacity': 'Passenger Capacity 1-3',
    'fleet_van_description': 'Our executive vans offer a comfortable and efficient solution for transporting individual crew members or small teams.\n\nWith spacious interiors, professional drivers, and reliable scheduling, these vehicles are perfect for early departures, late arrivals, and everything in between.',

    'fleet_sprinter_carousel_title': 'Sprinter',
    'fleet_sprinter_carousel_capacity': 'Passenger Capacity 1-14',
    'fleet_sprinter_carousel_description': 'Our Mercedes Sprinter vans provide premium comfort for medium-sized groups with ample luggage space.\n\nFeaturing luxury seating, climate control, and professional chauffeurs, these vehicles are ideal for crew transfers and group transportation needs.',

    'fleet_minivan_title': 'Minivan',
    'fleet_minivan_capacity': 'Passenger Capacity 1-7',
    'fleet_minivan_description': 'Our comfortable minivans are perfect for small to medium crew groups requiring reliable and efficient transportation.\n\nWith flexible seating arrangements and generous cargo space, these vehicles offer the perfect balance of comfort and practicality for airline crew needs.',

    'fleet_minibus_carousel_title': 'Minibus',
    'fleet_minibus_carousel_capacity': 'Passenger Capacity 1-25',
    'fleet_minibus_carousel_description': 'Our spacious minibuses are designed for larger crew groups, offering comfortable seating and ample luggage storage.\n\nWith air conditioning, reclining seats, and smooth ride quality, these vehicles ensure your crew arrives refreshed and ready for their duties.',

    'fleet_minicoach_title': 'Mini Coach',
    'fleet_minicoach_capacity': 'Passenger Capacity 1-35',
    'fleet_minicoach_description': 'Our premium mini coaches provide luxury transportation for large crew groups with maximum comfort and style.\n\nFeaturing plush seating, entertainment systems, and climate control, these coaches offer a first-class travel experience for your most important crew transfers.',

    // Passenger capacity
    'passenger_capacity': 'Passenger Capacity',
    'seats': 'seats',

    // How We Work section
    'how_we_work_title': 'How We Work',
    'how_we_work_description': 'Our commitment to excellence is built on three core principles that drive our service quality.',
    'how_we_work_card1_title': 'We are People-First',
    'how_we_work_card1_description': 'We\'ve never had a job too small, too big, and too complex for us; whether it\'s transporting one or two clients or up to 35 crew members, you can count on us.',
    'how_we_work_card2_title': 'Professional Drivers',
    'how_we_work_card2_description': 'Our drivers are professionally licensed, know their routes, drive their vehicles as safely as possible, and always treat our customers with high standards and courtesy.',
    'how_we_work_card3_title': 'Real-time Updates',
    'how_we_work_card3_description': 'Airline Crew Transportation has established an efficient centralized dispatch center to manage the daily dispatch of drivers and buses. Real-time GPS has been implemented to ensure the safety of all passengers.',

    // Contact section
    'contact_title': 'Contact Us',
    'contact_subtitle': 'Ready to get started? Reach out to us today and let us handle your transportation needs.',
    'contact_name': 'Name',
    'contact_name_placeholder': 'Your Full Name',
    'contact_name_required': 'Name is required',
    'contact_email': 'Email',
    'contact_email_placeholder': 'your@email.com',
    'contact_email_required': 'Email is required',
    'contact_email_invalid': 'Please enter a valid email address',
    'contact_phone': 'Phone',
    'contact_phone_placeholder': 'Your Phone Number',
    'contact_subject': 'Subject',
    'contact_subject_placeholder': 'Subject',
    'contact_subject_required': 'Subject is required',
    'contact_message': 'Message',
    'contact_message_placeholder': 'Your message',
    'contact_message_required': 'Message is required',
    'contact_submit': 'Submit',
    'contact_sending': 'Sending...',
    'contact_success': 'Your message has been sent successfully!',
    'contact_thank_you': 'Thank You!',
    'contact_success_message': 'Your message has been sent successfully. We\'ll get back to you shortly.',
    'contact_send_another': 'Send Another Message',
    'contact_hours': 'Hours',
    'contact_24_7': '24/7 Customer Service',

    // Footer
    'footer_copyright': 'Airline Crew Transportation. All Rights Reserved.',

    // Locations page
    'locations_page_title': 'Our Locations',
    'locations_page_subtitle': 'Serving major cities across the globe with premium transportation services',

    // San Francisco location
    'location_sf_title': 'San Francisco',
    'location_sf_description': 'Is Northern California\'s cultural, commercial, and financial center. The city is one of the most popular tourist destinations. It is also the home of Airline Crew Transportation\'s head office.',

    // Silicon Valley location
    'location_sv_title': 'Silicon Valley',
    'location_sv_description': 'is the Southern Portion of the San Francisco Bay Area. It Is home to many of the world\'s largest technology corporations. Among those are; The Fortune 1000, Adobe, eBay, Apple, Google, Facebook, and Tesla, to name a few.',

    // Miami location
    'location_miami_title': 'Miami',
    'location_miami_description': 'Miami sizzles all year round with exciting entertainment venues and attractions. Airline crew transportation has developed a strong working relationship with Miami\'s leading hotels and accommodations, giving your flight crew, first class & business class passengers access to the best of Miami.',

    // Los Angeles location
    'location_la_title': 'Los Angeles',
    'location_la_description': 'Los Angeles is the second-largest city in the USA and the most populous city in California. Airline Crew Transportation\'s second branch is conveniently located at the LAX airport in Los Angeles.',

    // New York City location
    'location_nyc_title': 'New York City',
    'location_nyc_description': 'New York City is ranked as the most photographed city in the world. It would be a pleasure to have your company join Airline Crew Transportation\'s growing list of happy customers loyal to us over the years because of our exceptional service.',

    // Fort Worth location
    'location_fw_title': 'Fort Worth',
    'location_fw_description': 'Fort Worth, a sprawling city, hums with energy and an independent spirit. We are currently doing business with the three major hotels in Dallas. We also shuttle four major airlines at Fort Worth Airport.',

    // Sydney location
    'location_sydney_title': 'Sydney, Australia',
    'location_sydney_description': 'Sydney is a destination you\'ll never forget, a city of iconic attractions and brilliant beaches. Airline crew Transportation in Sydney currently provides shuttle services for significant airlines\' flight and cabin crews and hotel shuttle programs for Sydney\'s most prestigious accommodations.',
  }
};

export default en; 